import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const WhyYourBrainWontLetGoSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel sectionId="why-your-brain-wont-let-go" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      The brain is designed to detect risk, not necessarily to interpret accurately. When an experience
      carries emotional significance, the brain stores it as a pattern to avoid future harm.
    </GuideLead>
    <p className="guide-panel__p">
      If a current situation resembles that pattern, the brain activates old memories, emotions, and
      assumptions—even if they are no longer relevant.
    </p>
    <p className="guide-panel__p">
      It keeps replaying the story because it seeks certainty and confirming evidence.
    </p>
    <GuideSectionLabel>Questions the mind keeps asking</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="thinking" title='"What if I&#39;m wrong?"' />
      <GuideCard iconKey="stress" title='"What if it happens again?"' />
      <GuideCard iconKey="communication" title='"Why did they say that?"' />
      <GuideCard iconKey="awareness" title='"Did I make a mistake?"' />
    </GuideCardGrid>
    <GuideCallout variant="amber">
      Without conscious reflection, the brain mistakes familiar thoughts for accurate ones.
    </GuideCallout>
    <GuideCallout>
      Mental clarity begins when you question the story instead of accepting it as truth.
    </GuideCallout>
  </GuidePanel>
);

export default WhyYourBrainWontLetGoSection;
